import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Customers from './Customers';
import POSPage from '../../pages/sales/POSPage';
import POSKeyboard from './POSKeyboard';
import ViewOrdersPage from '../../pages/sales/ViewOrdersPage';
import ReturnOrdersPage from '../../pages/sales/ReturnOrdersPage';
import ViewReturnsPage from '../../pages/sales/ViewReturnsPage';

const Sales = () => {
  return (
    <Routes>
      <Route path="customers" element={<Navigate to="/people/customers" replace />} />
      <Route path="pos" element={<POSPage />} />
      <Route path="pos-keyboard" element={<POSKeyboard />} />
      <Route path="returns" element={<ReturnOrdersPage />} />
      <Route path="view-orders" element={<ViewOrdersPage />} />
      <Route path="view-returns" element={<ViewReturnsPage />} />
    </Routes>
  );
};

export default Sales; 